// import { env } from '@/shared/config'
// import { Analytics } from '@/shared/lib/analytics'
// import { windowIdGet } from '@/shared/lib/windowId'

// export default defineNuxtPlugin({
//   name: 'analytics',
//   setup() {
//     const analytics = Analytics.create(!env.IS_PROD, windowIdGet())
//     return {
//       provide: {
//         analytics,
//       },
//     }
//   },
// })

import { analyticsState } from '@codestreet/analytics'
import { windowIdGet } from '@codestreet/utils'

import { env } from '@/shared/config'

export default defineNuxtPlugin({
  name: 'analytics',
  setup() {
    const analytics = analyticsState.create(!env.IS_PROD, windowIdGet())
    return {
      provide: {
        analytics,
      },
    }
  },
})
